<template>
  <v-content class="pa-2">
    <Submenu v-bind:title="'Wagons'"
      v-bind:right_buttons="submenu_right"
      v-on:menu-click="menu_click"
    />

    <v-row>
      <v-col cols="6">
        <WeekdayPicker class="d-inline-flex pa-2" :selectedDays.sync="selectedDays">
        </WeekdayPicker>
      </v-col>
      <!-- <v-col cols="5" class="text-end"> -->
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn tile ripple outlined color="success" v-on="on" class="mt-0 dense"
              @click="manualAddDialog = true">
              <v-icon>mdi-shape-rectangle-plus</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Add Production Manually')}}</span>
        </v-tooltip> -->
        <!-- <v-btn class="ma-2"
          tile outlined color="success"
          @click="print()"
          ripple>
          <v-icon left>mdi-file-search</v-icon> {{$t('Report')}}
        </v-btn>
      </v-col> -->
    </v-row>
    <ManualWagonDialog v-bind:value="manualAddDialog" v-on:close="manualAddDialog =false"></ManualWagonDialog>
    <AddEditWagon v-bind:value.sync="showDialog"
                  v-bind:wagonId="currentWagonId"
                  v-on:close="close"
                  v-on:delete="removeWagon(currentWagonId)">
    </AddEditWagon>
    <v-container fluid>
    <div class="left-side mx-1" >
      <v-layout wrap>
      <!-- add wagon card... -->
      <drop  class="drop" ref="over" @drop="handleDrop('ADD', 0, ...arguments)">
          <v-card width="200px" outlined class="rounded-card add-card ma-2" >
            <v-layout align-center justify-center>
                <v-card-title class="pa-1 my-3">{{$t('Add Wagon')}}</v-card-title>
            </v-layout>
          </v-card>
      </drop>
      <!-- ..end of Add card -->
      <drop v-for="wagon in wagons" :key="wagon.id" class="drop" ref="over"
        @drop="handleDrop(wagon.id, wagon.tmr.code, ...arguments)"
        >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-card width="200px" outlined v-on="on"
                class="rounded-card ma-2">
              <v-layout align-center>
                <v-flex sx3>
                  <v-avatar color="primary" size="36" left class="ma-2 my-3" >
                    <span class="white--text headline">{{wagon.order}}</span>
                  </v-avatar>
                </v-flex>
                <v-flex sx9>
                  <v-card-text class="pa-1 mt-2 white--text subtitle-2">{{wagon.name}} [{{wagon.tmr.code}}]</v-card-text>
                  <v-layout justify-start>
                  <v-flex xs7>
                    <v-card-text v-if="wagon.groups.length > 0" class="pa-1">
                      {{wagonTotal(wagon) | kgString}}
                    </v-card-text>
                  </v-flex>
                  <v-flex xs5 class="mr-2">
                    <v-badge color="orange darken-2" overlap>
                      <template v-slot:badge>
                        <span v-if="wagon.groups.length > 0" >{{wagon.groups.length}}</span>
                      </template>
                      <v-btn icon small
                        color="orange darken-1" class="ms-2"
                        :class="wagon.groups.length == 0 ? 'me-6' :''"
                        @click.stop="edit(wagon.id)"
                        >
                        <v-icon>mdi-reorder-horizontal</v-icon>
                      </v-btn>
                    </v-badge>
                  </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </template>
          <span>{{daysToName(wagon.onlyForDays)}}</span>
        </v-tooltip>
      </drop>
      </v-layout>
    </div>
    <div class="right-side" >
        <v-layout wrap>
          <drag v-for="grp in groups" :key="grp.Id+grp.tmrCode"
            class="drag"
            @dragstart="dragStart"
            :transfer-data="[grp.Id, grp.tmrCode]">
          <v-flex class="ma-3">
            <MiniGroupPanel v-bind:groupId="grp.Id" v-bind:tmrCode="grp.tmrCode" />
          </v-flex>
          </drag>
        </V-layout>
    </div>
    </v-container>
  </v-content>
</template>

<script>
import { Drag, Drop } from "vue-drag-drop";
import MiniGroupPanel from "../components/MiniGroupPanel";
import WeekdayPicker from "../components/WeekdayPicker";
import AddEditWagon from "../components/AddEditWagon";
import WagonPlanPrint from "./WagonPlanPrint.vue";
import ManualWagonDialog from "../components/AddManualWagon";
import Submenu from "../components/common/submenu";

export default {
  components: {
    Drag,
    Drop,
    MiniGroupPanel,
    WeekdayPicker,
    AddEditWagon,
    ManualWagonDialog,
    Submenu
  },
name: "WagonsPage",
data() {
    return {
      currentWagonId: "",
      showDialog: false,
      showTouchAlert: false,
      manualAddDialog: false,
      submenu_right:[
        {
          index: 0,
          text: '',
          icon: 'mdi-shape-rectangle-plus',
          tooltip: this.$i18n.t('Add Production Manually')
        },
        {
          index: 1,
          text: this.$i18n.t("Report"),
          icon: 'mdi-file-search',
          tooltip: this.$i18n.t('Print daily production plan')
        }
      ],
    };

  },
  created: function() {
    this.showDialog = false;
    //const needAlert = document.cookie;
    this.showTouchAlert = false; // (not) needAlert.includes("showTouchAlert");
  },
  computed: {
    groups() {
      return this.$store.getters.getMiniGroups
    },
    wagons() {
      return this.$store.getters.getWagons;
    },
    selectedDays() {
      return this.$store.getters.getSelectedDays;
    },
    isRtl: function() {
      //make drawer on right for he locale
      return this.$i18n.locale == "he";
    }
  },
  methods: {
    wagonTotal(wagon) {
      if (wagon && wagon.groups && wagon.groups.length > 0) {
        // return wagon.groups.reduce(function (a, g) {
        //   return isNaN(Number(g['qty'])) ? a : a + g['qty'];
        //   }, 0);
        return this.$store.getters.weekdayQty(wagon)
                .reduce( (a, g) => a>g ? a : g);
      }
      else
        return -99;
    },
    menu_click: function(btnIndex) {
      if (btnIndex == 0)
        this.manualAddDialog = true;
      if (btnIndex == 1)
        this.print();
    },
    touchAlertNoShow() {
      this.showTouchAlert = false;
      const cookieExpire = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
      document.cookie = "showTouchAlert=0; expires=" + cookieExpire.toString();
    },
    print() {
      this.$router.push(WagonPlanPrint);
    },
    close() {
      this.showDialog=false;
    },
    removeWagon(id) {
      this.showDialog=false;
      this.$nextTick(()=> {
        let _wgnName = this.$store.getters.getWagon(id).name.slice();
        this.$store.dispatch("deleteWagon", id);
        this.$root.$globalSnackbar(this.$i18n.t('wagon removed', [_wgnName]), "info");
      });
    },
    edit(editId) {
      this.currentWagonId=editId;
      this.showDialog=true;
    },
    handleDrop(wagonId, wagonTmrCode, grpInfo) {
        this.over = false;
        if (grpInfo[1] == ""){
            this.$root.$globalSnackbar(this.$i18n.t('This group does not have a TMR specified, update group'), "error");
            return
        }
        if (wagonId == "ADD" || wagonTmrCode == grpInfo[1]){
          let data = {wagonId: wagonId, groupId: grpInfo[0], tmrCode: grpInfo[1], vm: this };
          this.$store.dispatch("addGroupToWagon", data);
        } else {
          this.$root.$globalSnackbar(this.$i18n.t('wagon making different tmr', [wagonTmrCode]), "error");
        }
    },
    dragStart(grpInfo) {
       if (grpInfo[1] == ""){
            this.$root.$globalSnackbar(this.$i18n.t('This group does not have a TMR specified, update group'), "error");
            return
        }
    },
    dragEnter(idx) {
      this.$refs.over[idx].$el.classList.add("over");
      //console.log("Enter")
    },
    dragLeave(idx) {
        this.$refs.over[idx].$el.classList.remove("over");
        //console.log("Leave")
    },
    daysToName(days) {
      const names =["*", this.$i18n.t('Sun'), this.$i18n.t('Mon'), this.$i18n.t('Tue'), this.$i18n.t('Wed'), this.$i18n.t('Thu'), this.$i18n.t('Fri'), this.$i18n.t('Sat') ];
      let ret=""  ;
      if (days && days.length >0)
        if (days.length == 7)
          return this.$i18n.t('All days of the week')
        else {
          days.forEach(d => ret += names[d] + ", ");
          return ret.substring(0, ret.length - 2);
        }
      else
        return this.$i18n.t('This Wagon is not used in any weekday')
    }
  }
}
</script>

<style scoped>
  .rounded-card {
    border-radius:10px;
  }
  .add-card {
    border-width: 4px !important;
    border-color: rgb(60, 113, 165) !important;
  }

  .left-side {
    width: 49%;
    float: left;
    /* margin-left: 2px; */
  }
  .right-side {
    width: 49%;
    float: right;
  }

  .drop.over {
     border-color: #aaa;
     background: #ccc;
  }
  .align-center {
    display: flex;
    align-items: center;
  }
</style>